<template>
    <div class="app">
      <div class="navbar" v-if="app">
        <img :src="app.image" class="logo" alt="">
      </div>

      <router-view :app="app" v-if="loaded"/>
      <div class="loader" v-else>
        <b-spinner type="grow"></b-spinner>
      </div>
    </div>
  </template>
  
<script>
import config from '../config';

import Chat from './Chat.vue';

export default {
  name: 'App',
  components: {
    Chat
  },
  data () {
    return {
      loaded: false,
      app: null,
      appId: null
    }
  },
  methods: {
    async getApp() {

      const token = localStorage.getItem('token') || '';

      fetch(`${config.api}/app/${this.appId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      })
        .then(response => response.json())
        .then(data => {
          this.app = data;
          this.loaded = true;

          document.title = `${this.app.name} Chatbot - demo`;
        })
        .catch((error) => {
          this.$router.push('/login');
        });
    }
  },
  created() {
    this.appId = this.$route.params.appId;

    this.getApp();
  }
}
</script>

<style scoped>
.app {
  height: 100%;
}

.navbar {
    background-color: #f8f9fa;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 80px;

    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

}

.logo {
    height: 40px;
    padding: 10px;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}

</style>



// WEBPACK FOOTER //
// src/components/App.vue